import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import '@/assets/css/style.css';

import AppView from "./app";


createApp(App)
  .use(router)
  .use(store)
  .use(AppView)
  .mount("#app");
